// extracted by mini-css-extract-plugin
module.exports = {"post-tag":"PostTag_post-tag__TZj8A","post-tag--item":"PostTag_post-tag--item__29WfK","post-tag2":"PostTag_post-tag2__1ANh7"};